// extracted by mini-css-extract-plugin
export default {"box":"index_box__TETXL","content":"index_content__mqvLk","lottie":"index_lottie__4vktp","tip":"index_tip__KLx5l"};